<p class="info info--error" translate>auth.resetPassword.invalidHash</p>
<p class="info-text" [routerLink]="['/recover-password']" [innerHTML]="'auth.resetPassword.resign' | translate"></p>



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/auth/reset-password/reset-password-invalid/reset-password-invalid.component.html